import React, { FC } from 'react';
import { IconSVGProps } from '../Icon';

export const EmailSendIcon: FC<IconSVGProps> = ({
  width = 52,
  height = 52,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 52 52"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <polygon
        id="path-1"
        points="1.99198863e-15 0 52 0 52 52.0091483 0 52.0091483"
      />
      <path
        d="M47.7071405,13.1114629 L23.7928595,13.1114629 C21.4266976,13.1114629 19.5,15.1138766 19.5,17.5773314 L19.5,32.4789277 C19.5,34.9423825 21.4266976,36.9447962 23.7928595,36.9447962 L47.7071405,36.9447962 C50.0744998,36.9447962 52,34.9423825 52,32.4789277 L52,17.5773314 C52,15.1138766 50.0744998,13.1114629 47.7071405,13.1114629 L47.7071405,13.1114629 Z M47.6666667,15.2781296 C48.8632836,15.2781296 49.8333333,16.2481793 49.8333333,17.4447962 L49.8333333,32.6114629 C49.8333333,33.8080798 48.8632836,34.7781296 47.6666667,34.7781296 L23.8333333,34.7781296 C22.6367164,34.7781296 21.6666667,33.8080798 21.6666667,32.6114629 L21.6666667,17.4447962 C21.6666667,16.2481793 22.6367164,15.2781296 23.8333333,15.2781296 L47.6666667,15.2781296 Z M23.3704365,18.1177575 C23.1176412,18.5605195 23.2608919,19.131025 23.6906439,19.3914733 L35.0459693,26.2859093 C35.1880162,26.3727253 35.3457124,26.4148931 35.5046123,26.4148931 C35.6635122,26.4148931 35.8224121,26.3727253 35.964459,26.2859093 L47.169311,19.4596859 C47.5978593,19.1979974 47.7399062,18.6274919 47.485907,18.1859701 C47.2331117,17.7432082 46.6793696,17.5981013 46.2496175,17.8585495 L35.5034085,24.4044811 L24.6067261,17.7890967 C24.1745664,17.5236876 23.6244356,17.6762358 23.3704365,18.1177575 Z M9.75,30.3333333 L11.9166667,30.3333333 C12.5149751,30.3333333 13,30.8183582 13,31.4166667 C13,32.0149751 12.5149751,32.5 11.9166667,32.5 L9.75,32.5 C9.15169152,32.5 8.66666667,32.0149751 8.66666667,31.4166667 C8.66666667,30.8183582 9.15169152,30.3333333 9.75,30.3333333 Z M5.41666667,23.8333333 L11.9166667,23.8333333 C12.5149751,23.8333333 13,24.3183582 13,24.9166667 C13,25.5149751 12.5149751,26 11.9166667,26 L5.41666667,26 C4.81835819,26 4.33333333,25.5149751 4.33333333,24.9166667 C4.33333333,24.3183582 4.81835819,23.8333333 5.41666667,23.8333333 Z M1.08333333,17.3333333 L11.9166667,17.3333333 C12.5149751,17.3333333 13,17.8183582 13,18.4166667 C13,19.0149751 12.5149751,19.5 11.9166667,19.5 L1.08333333,19.5 C0.485024854,19.5 0,19.0149751 0,18.4166667 C0,17.8183582 0.485024854,17.3333333 1.08333333,17.3333333 Z"
        id="path-333"
      />
    </defs>
    <g
      id="SBox-2.0"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Onboarding-0" transform="translate(-353.000000, -120.000000)">
        <rect fill="#FFFFFF" x="0" y="0" width="1440" height="900" />
        <g id="Group-5" transform="translate(330.000000, 108.000000)">
          <rect
            id="Rectangle"
            fillOpacity="0.90286703"
            fill="#FFA200"
            x="0"
            y="0"
            width="1050"
            height="76"
            rx="17"
          />
          <g
            id="Icons/Global/Email-Send-1"
            transform="translate(23.000000, 12.000000)"
          >
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <g id="Clip-2" />
            <mask id="mask-4" fill="white">
              <use xlinkHref="#path-333" />
            </mask>
            <use id="Fill-1" fill="#FFFFFF" xlinkHref="#path-333" />
            <g id="Colors/Black" mask="url(#mask-4)" fill="#FFFFFF">
              <rect id="Rectangle" x="0" y="0" width="52" height="52" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
